<!-- MFITTで発車1分後を過ぎて払い戻し操作をした場合 -->
<template>
  <ItemDialog ref="canNotRefundAfterDeparture" image-type="alert">
    <template #content-area>
      <p class="text-center">
        払いもどし期限を過ぎたため払いもどしはできません。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotRefundAfterDeparture",
  setup() {
    const canNotRefundAfterDeparture = ref(null);

    const openDialog = () => {
      canNotRefundAfterDeparture.value.open();
    };

    const closeDialog = () => {
      canNotRefundAfterDeparture.value.close();
    };

    return {
      canNotRefundAfterDeparture,
      openDialog,
      closeDialog,
    };
  },
};
</script>
